import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Helps } from 'src/app/libs/helps';
import { Users } from 'src/app/models/interfaces/users';
import { ApiEntryControlService } from '../../api-entry-control.service';
import { Stores } from '../../interfaces/stores';

@Component({
  selector: 'app-information-panel',
  standalone: false,
  templateUrl: './information-panel.component.html',
  styleUrl: './information-panel.component.css'
})
export class InformationPanelComponent implements OnInit, OnChanges {

  error: any;
  constructor(
    private api: ApiEntryControlService,
    private modal: NgbModal,
    private toast: ToastrService,
    private router: Router,
    private helps: Helps
  ) { }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['storesId'].currentValue != this.storesId) {
      this.get();
    }
  }
  default:string;
  level: number = 0;
  view: number = 1;
  status: any;
  selected?: Users;
  ngOnInit(): void {
    this.get();
    this.level = this.helps.getToken()?.level ?? 0;
  }
  @Input()
  storesId: number;

  items: Users[];
  page = 1;
  perpage: number = 0;
  collectionSize = 0;
  totalPage = 0;

  brands: any;
  form = new UntypedFormGroup({
    id: new UntypedFormControl(),
    content: new UntypedFormControl(''),
  });
  get() {
    this.api.getContentStore(this.storesId).subscribe((rs) => {
      var data = rs.data as Stores;
      this.form.patchValue(data);
    }, e => { 

      this.toast.warning('No existe información almacenada.');
    });
  }
  openModal(md: any, size: string = 'md') {
    this.modal.open(md, {
      size: size,
    });
  }

  save() {
    if (this.level < 99) {
      this.toast.warning("No tiene los privilegios para editar esta sección");
      return;
    }
    this.form?.get('id')?.setValue(this.storesId);
    this.api.saveInfoStore(this.form).subscribe(
      (response) => {
        this.toast.success(
          response.msg,
          'Panel de información actualizado'
        );
      },
      (error) => {
        this.toast.warning(error.error.mistakes, 'Tenemos un error', {
          enableHtml: true,
          closeButton: true
        });
      }
    );
  }
  clean() { }
}

